import React from 'react';

const ContactPage = () => {
  return (
    <div>
      <h1>Contact Us</h1>
      {/* You can add a form, contact details, or any content here */}
    </div>
  );
};

export default ContactPage;
